import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Chip, InputLabel, Grid } from '../../';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'start',
      flexWrap: 'wrap'
    },
    options: {
      display: 'flex' // 'margin-bottom': ' 20px'

    },
    formControl: {
      margin: '20px 0px'
    },
    chip: {
      margin: "".concat(theme.spacing(0.5), " !important"),
      backgroundColor: '#e2e2e2 !important',
      // backgroundColor: theme.palette.disabledColor,
      color: 'black !important',
      'min-width': '110px !important',
      'margin-right': '10px !important' // width: '200px'

    },
    active: {
      margin: "".concat(theme.spacing(0.5), " !important"),
      backgroundColor: '#33ff99 !important',
      // backgroundColor: theme.palette.primary.main,
      color: 'black !important',
      'min-width': '110px !important',
      'margin-right': '10px !important'
    }
  };
});

var ChipSelect = function ChipSelect(props) {
  var classes = useStyles();

  var _useState = useState(props.options),
      _useState2 = _slicedToArray(_useState, 2),
      chipData = _useState2[0],
      setChipData = _useState2[1];

  var onChange = function onChange(chip) {
    var value = chip.selected ? chip.value : '';
    props.form.setFieldValue(props.field.name, value);
  };

  useEffect(function () {
    var selected = '';

    if (props.options && props.field.value !== '') {
      selected = props.options.find(function (option) {
        return option.value === props.field.value;
      });

      if (selected) {
        var _chipData = _toConsumableArray(chipData);

        _chipData.forEach(function (chip) {
          chip.value === selected.value ? chip.selected ? toggleSelected(chip) : chip.selected = true : chip.selected = false;
        });

        setChipData(_chipData);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);

  var toggleSelected = function toggleSelected(selectedChip) {
    selectedChip.selected = !selectedChip.selected;
  };

  var handleStatus = function handleStatus(selectedChip) {
    var _chipData = _toConsumableArray(chipData);

    _chipData.forEach(function (chip) {
      chip.value === selectedChip.value ? chip.selected ? toggleSelected(chip) : chip.selected = true : chip.selected = false;
    });

    setChipData(_chipData);
    onChange(selectedChip);
  };

  var handleClick = function handleClick(chip) {
    var selectedChip = chipData.find(function (_chip) {
      return _chip.value === chip.value;
    });
    handleStatus(selectedChip);
  };

  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.root
  }, /*#__PURE__*/React.createElement(InputLabel, {
    className: classes.formControl
  }, props.label), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.options
  }, chipData && chipData.map(function (data, i) {
    var icon;
    return data.tooltip ? /*#__PURE__*/React.createElement(Tooltip, {
      title: data.tooltip,
      placement: "top",
      TransitionComponent: Fade,
      TransitionProps: {
        timeout: 600
      }
    }, /*#__PURE__*/React.createElement(Chip, {
      key: i,
      icon: icon,
      label: data.label,
      className: data.selected ? classes.active : classes.chip,
      clickable: props.clickable,
      onClick: function onClick() {
        if (props.clickable) handleClick(data);
      }
    })) : /*#__PURE__*/React.createElement(Chip, {
      key: i,
      icon: icon,
      label: data.label,
      className: !data.selected ? classes.chip : classes.active,
      clickable: props.clickable,
      onClick: function onClick() {
        if (props.clickable) handleClick(data);
      }
    });
  })));
};

export { ChipSelect };